import Marquee from "react-fast-marquee";
import SponsorsData from "../static/SponsorsData";
import getImageLogosSrcSet from "../helper/ImageKit";

const RunningBanner = ({ data, className }) => { 
  return (
    <div>
      <Marquee
        speed={70}
        pauseOnHover={true}
        gradient={false}
      >
      {data.map((d) => {
        const img = getImageLogosSrcSet(d.logoPath);
        return (
          <img
            key={d.id}
            src={img.src}
            srcSet={img.srcSet}
            sizes={img.sizes}
            alt="Sponsor logo"
            className={className}
          />
        );
      })}
      </Marquee>
    </div>
  );
}

export default RunningBanner;